export default "__VITE_ASSET__DxAeIjVV__"